import gql from 'graphql-tag';
import { ArticlesForCcaStep2Query_allArticles_edges_node } from './__generated__/ArticlesForCcaStep2Query';

// Step 2 fetches the selected articles by id. We reuse the generic `allArticles`
// query with its `articleIds` filter instead of a dedicated endpoint.
export const ARTICLES_FOR_CCA_STEP2_QUERY = gql`
  query ArticlesForCcaStep2Query($filter: AllArticlesFilterInput, $limit: Int) {
    allArticles(filter: $filter, limit: $limit) {
      edges {
        node {
          id
          url
          title
          manualExpirationTime
          facebookPageId
          facebookPage {
            id
            facebookPageDisplayName
          }
        }
      }
    }
  }
`;

export type CcaStep2Article = ArticlesForCcaStep2Query_allArticles_edges_node;
